import React from "react";
import { Button, Modal, Form, Table } from "react-bootstrap";
import { useLicensing } from "./useLicensing";
import MobileLicensingModal from "../mobileLicensingModal";
import { IBaseLicenseDetails } from "../../../common/types/mobileLicensingTypes";
import {ACTION,LICENSE_TYPES} from '../../../common/constants';
interface IProps {
  orgId: string;
  orgName: string;
}

const LicensingModal = (props: IProps) => {
  const {
    show,
    handleClose,
    handleShow,
    activeLicense,
    setActiveAction,
    setActiveLicense,
    activeAction,
    organisationLicensingDetails,
    handleCloseNestedModal
  } = useLicensing(props.orgId);
  const handleOpen = (license, action) => {
    setActiveLicense(license);
    setActiveAction(action);
  };
  const {orgId,orgName}=props;
  return (
    <>
      <div onClick={handleShow}>
        <span>Licenses</span>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container create-new-org-admin"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Licenses</Modal.Title>
        </Modal.Header>
        <Form>
          <Modal.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>License Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {organisationLicensingDetails.map((license,index) => {
                  const licenseDetailsKey=Object.keys(license).find((key)=>key!=='type'&&key!=='name')??'';
                  if(!licenseDetailsKey) return null;
                  const licenseDetails=license[licenseDetailsKey] as IBaseLicenseDetails;
                  return (
                  <tr key={index}>
                    <td>{license.name}</td>
                    <td>
                      {licenseDetails?.isActive ? (
                        <span className="text-success">Enabled</span>
                      ) : (
                        <span className="text-danger">Disabled</span>
                      )}
                    </td>
                    <td>
                      {licenseDetails?.isActive ? (
                        <div className="mobile-licensing-tab">         
                          <button
                            onClick={() => handleOpen(license, ACTION.MANAGE)}
                          >
                            Manage
                          </button>
                          {"  "}
                          <button
                            onClick={() => handleOpen(license, ACTION.DISABLE)}
                          >
                            Disable
                          </button>
                        </div>
                      ) : (
                        <div className="mobile-licensing-tab">  
                        <button
                          onClick={() => handleOpen(license, ACTION.ENABLE)}
                        >
                          Enable
                        </button>
                         </div>
                      )}
                    </td>
                  </tr>
                )})}
              </tbody>
            </Table>
            {activeLicense?.type === LICENSE_TYPES.MOBILE && (
              <MobileLicensingModal
                orgId={orgId}
                license={activeLicense}
                action={activeAction}
                show={!!activeLicense}
                onClose={handleCloseNestedModal}
                orgName={orgName}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-cancel" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default LicensingModal;
